import i18n from '@/i18n';
import { RouteRecordRaw } from 'vue-router';

const dashboardRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'logent-dashboard-overview',
      component: () => import('@/modules/logent-dashboard/components/overview/DashboardOverview.vue'),
      meta: {
         title: `${i18n.global.t('global.dashboard')} - NxtPlan`,
      },
   },
];
export default dashboardRoutes;
